import { paymentSettingConstants } from "../constants/paymentSettingConstants";
import { paymentSettingService } from "../../services/API/paymentSettingService";
import { alertActions } from "./alert.actions";
import { history } from "../store/configureStore";
import Alert from "../../components/alert/Alert";

export const paymentSettingActions = {
  savePaymentSetting,
  getPaymentSetting,
  getFrontPaymentSetting,
};

export const savePaymentSetting = postData => {
  return dispatch => {
    paymentSettingService.savePaymentSetting(postData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: paymentSettingConstants.ADD_PAYSETTING_REQUEST, data };
  }
  function success(data) {
    return { type: paymentSettingConstants.ADD_PAYSETTING_SUCCESS, data };
  }
  function failure(error) {
    return { type: paymentSettingConstants.ADD_PAYSETTING_FAILURE, error };
  }
};

export const getPaymentSetting = (postData) => {
  return dispatch => {
    paymentSettingService.getPaymentSetting(postData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: paymentSettingConstants.GET_PAYSETTING_REQUEST, data };
  }
  function success(data) {
    return { type: paymentSettingConstants.GET_PAYSETTING_SUCCESS, data };
  }
  function failure(error) {
    return { type: paymentSettingConstants.GET_PAYSETTING_FAILURE, error };
  }
};


export const getFrontPaymentSetting = (postData) => {
  return dispatch => {
    paymentSettingService.getFrontPaymentSetting(postData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: paymentSettingConstants.GET_PAYSETTING_REQUEST, data };
  }
  function success(data) {
    return { type: paymentSettingConstants.GET_PAYSETTING_SUCCESS, data };
  }
  function failure(error) {
    return { type: paymentSettingConstants.GET_PAYSETTING_FAILURE, error };
  }
};


// WEBPACK FOOTER //
// ./src/app/redux/actions/payemntSettingAction.js